// extracted by mini-css-extract-plugin
export default {"container":"ydYOl8","contentContainer":"kF0Xuq","headerLine":"W5BJXv","descriptionLine":"HLbuE5","closeIcon":"jPlqJH"};